import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from 'react'

type JenisToast = 'sukses' | 'gagal' | 'info'

interface ItemToast {
  id: number
  jenis: JenisToast
  pesan: string
}

interface NilaiToast {
  sukses: (pesan: string) => void
  gagal: (pesan: string) => void
  info: (pesan: string) => void
}

const KonteksToast = createContext<NilaiToast | null>(null)

let penghitung = 0

export function ToastProvider({ children }: { children: ReactNode }) {
  const [daftar, setDaftar] = useState<ItemToast[]>([])

  const tambah = useCallback((jenis: JenisToast, pesan: string) => {
    penghitung += 1
    const id = penghitung
    setDaftar((d) => [...d, { id, jenis, pesan }])
    window.setTimeout(() => {
      setDaftar((d) => d.filter((x) => x.id !== id))
    }, 6000)
  }, [])

  const nilai = useMemo<NilaiToast>(
    () => ({
      sukses: (p) => tambah('sukses', p),
      gagal: (p) => tambah('gagal', p),
      info: (p) => tambah('info', p),
    }),
    [tambah],
  )

  return (
    <KonteksToast.Provider value={nilai}>
      {children}
      <div
        className="pointer-events-none fixed bottom-4 right-4 z-[60] flex w-80 flex-col gap-2"
        role="status"
        aria-live="polite"
      >
        {daftar.map((t) => (
          <div
            key={t.id}
            className={`pointer-events-auto rounded-lg border px-4 py-3 text-sm shadow-lg ${
              t.jenis === 'sukses'
                ? 'border-yayasan-300 bg-yayasan-50 text-yayasan-900'
                : t.jenis === 'gagal'
                  ? 'border-red-300 bg-red-50 text-red-800'
                  : 'border-netral-300 bg-white text-netral-800'
            }`}
          >
            <p className="font-semibold">
              {t.jenis === 'sukses' ? 'Berhasil' : t.jenis === 'gagal' ? 'Gagal' : 'Informasi'}
            </p>
            <p className="mt-0.5 break-words">{t.pesan}</p>
          </div>
        ))}
      </div>
    </KonteksToast.Provider>
  )
}

export function useToast(): NilaiToast {
  const ctx = useContext(KonteksToast)
  if (!ctx) {
    // Fallback aman (mis. komponen diuji di luar provider): tampilkan di konsol.
    return {
      sukses: (p) => console.info('[sukses]', p),
      gagal: (p) => console.warn('[gagal]', p),
      info: (p) => console.info('[info]', p),
    }
  }
  return ctx
}
